/**
 * After apply/revert the server already runs post-correction verification.
 * Re-use that payload instead of triggering a second full integrity scan.
 */

export function buildScanFromVerification(verification, previousScan) {
  if (!verification || verification.quick_verification) {
    return null;
  }
  if (!verification.findings && !verification.sections) {
    return null;
  }

  const base = previousScan?.status ? { ...previousScan } : { status: true };

  return {
    ...base,
    findings: verification.findings ?? base.findings ?? [],
    sections: verification.sections ?? base.sections ?? [],
    health: verification.health ?? base.health ?? null,
    summary: verification.summary ?? base.summary ?? null,
    playbook: verification.playbook ?? base.playbook ?? null,
    scan_range: verification.scan_range ?? base.scan_range ?? null,
    bs_pl_balanced: verification.bs_pl_balanced ?? base.bs_pl_balanced,
  };
}

/**
 * @returns {{ scanPatch: object|null, needsFullScan: boolean }}
 */
export function planPostCorrectionRefresh(applyResponse, previousScan) {
  const verification = applyResponse?.verification || applyResponse?.apply_result?.verification;
  const scanPatch = buildScanFromVerification(verification, previousScan);

  return {
    scanPatch,
    needsFullScan: !scanPatch && Boolean(verification?.quick_verification),
    verification,
  };
}

export function previewParamsFingerprint(fixType, params = {}) {
  const keys = [
    'from_date',
    'to_date',
    'product_id',
    'baseline_audit_id',
    'entity_type',
    'entity_id',
    // A reviewed stock override staged for nf_stock_reconcile — must invalidate the old preview
    // so "Apply fix" stays disabled until the admin re-previews with the override included.
    'confirm_override',
  ];
  return JSON.stringify({
    fix_type: fixType,
    ...Object.fromEntries(keys.filter((k) => params[k] != null && params[k] !== '').map((k) => [k, params[k]])),
  });
}
